import React from 'react'
import { APPConfig } from 'config/appConfig'
import SubscriptionsView1 from './SubscriptionsView1'
import { enableMultipleSubscription } from 'src/utils'
import { FlexibleSubscriptions } from 'src/views/pages/MyAccount/FlexibleSubscriptions'
import { MultipleSubscriptions } from 'src/views/pages/MyAccount/MultipleSubscriptions'

class Subscriptions extends React.Component {
  render() {
    const isEnableMultipleSubscription = enableMultipleSubscription()
    return (
      <>
        {isEnableMultipleSubscription ? (
          <MultipleSubscriptions {...this.props} />
        ) : APPConfig?.getAppConfig()?.enableFlexibleSubscription === 'true' ? (
          <FlexibleSubscriptions {...this.props} />
        ) : (
          <SubscriptionsView1 {...this.props} />
        )}
      </>
    )
  }
}

export default Subscriptions
export { Subscriptions }
